<template>
    <div>
        <div class="mask" id="index" v-if="show">
            <div class="pos-f bottom0 left0 right0 bg-white"
                 :style="upVipBaseInfo.totalDiscounts ? 'height:70%;border-top-left-radius:8px;border-top-right-radius:8px;' : 'max-height:70%;border-top-left-radius:8px;border-top-right-radius:8px;'">
                <div class="text-center fs-16 pos-r paddingv20">
                    开通UP会员 立享优惠
                    <i class="icon-close pos-a paddingh30 paddingv20 top0 right0"
                       style="line-height:24px;"
                       data-scp="hyclose.0"
                       @click="hidePanel"></i>
                </div>
                <div style="overflow-y: scroll;height: calc(100% - 45px);padding-bottom:60px;">
                    <div class="paddingh30" v-show="upVipBaseInfo.totalDiscounts">
                        <div class="flex-container paddingv20 fs-14">
                            <div v-show="source === 'cartList'">购物车中选中商品</div>
                            <div v-show="source === 'preOrder'">该笔订单</div>
                            <div v-show="source === 'listing'">天狗价<span class="fs-18">¥{{ tgPrice }}</span></div>
                            <div class="text-red">会员预计可省¥{{ upVipBaseInfo.totalDiscounts }}</div>
                        </div>
                        <div style="border-radius:8px;background: #F5F4F9;">
                            <div v-if="upVipBaseInfo.couponDiscounts && source !== 'listing'">
                                <div class="flex-container padding20" v-for="coupon in upVipBaseInfo.couponDiscounts">
                                    <span class="text-dark">{{ coupon.couponName }}</span>
                                    <span>-¥{{ coupon.couponDiscounts }}</span>
                                </div>
                            </div>
                            <div v-if="upVipBaseInfo.couponName && source === 'listing'" class="flex-container padding20">
                                <span class="text-dark">{{ upVipBaseInfo.couponName }}</span>
                                <span>-¥{{ upVipBaseInfo.couponDiscounts }}</span>
                            </div>
                            <div class="flex-container padding20"
                                 v-if="source === 'listing' && upVipBaseInfo.vipDiscounts > 0"><span class="text-dark">
                                UP会员价¥{{upVipBaseInfo.vipPrice}}</span><span>-¥{{ upVipBaseInfo.vipDiscounts }}</span></div>
                            <div class="flex-container padding20"
                                 v-if="source!== 'listing' && upVipBaseInfo.vipDiscounts > 0">
                                <span class="text-dark">UP会员优惠</span>
                                <span>-¥{{upVipBaseInfo.vipDiscounts}}</span>
                            </div>
                        </div>
                        <div class="paddingv20 fs-10 text-dark">
                            提示:可能会因为参加了其他优惠活动导致会员省钱数变低，具体以下单时为准
                        </div>
                    </div>
                    <div class="paddingh30" style="border-top:.2666666667rem solid #F8F8F8;">
                        <div class="flex-container paddingv30">
                            <div class="flex-container left">
                                <img src="//image1.51tiangou.com/tgou2/img2/product/ico-up.png" width="25" alt="">
                                <span class="marginl10 fs-14">会员权益</span>
                            </div>
                            <a href="/payCard.html" style="color:#000;">
                                <div class="flex-container right fs-12" data-scp="hyqy.0">
                                    查看更多会员权益
                                    <span class="icon-right marginl10"></span>
                                </div>
                            </a>

                        </div>
                    </div>
                    <div class="paddingh20">
                        <div class="up-box scroll-container">
                            <div class="padding20 marginh10"
                                 v-for="(index, coupon) in upVipBaseInfo.vipCouponList"
                                 :key="index"
                                 v-if="coupon.name">
                                <span class="lh-1" style="font-size:28px;"><span class="fs-12">￥</span>{{ coupon.value }}</span>
                                <span class="fs-12 margint10 lh-1">{{ coupon.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="paddingh30 paddingb50">
                        <div class="margint20 up-list" style="background: #F5F4F9;border-radius: 8px;">
                            <div class="flex-container text-center paddingt50 paddingb40">
                                <div class="flex1" v-for="(index, item) in upVipDis" :key="index">
                                    <a :href="`/payCard.html#/memberRight?memberIndex=${index}`"
                                       :data-scp="`icon.${index}`">
                                        <div><img :src="item.icon" width="40" alt=""></div>
                                        <div class="margint10">
                                            <div class="fs-12 text-black">{{ item.title }}</div>
                                            <div class="fs-10 text-dark">{{ item.subTitle }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="pos-a bottom20 left0 right0">
                            <div class="up-btn flex-container center margint40 marginh20 paddingv10 pos-r"
                                 @click="buyUpVip" data-scp="tcopen.0">
                                <img src="//image1.51tiangou.com/tgou2/img2/product/ico-up.png" width="25" alt="">
                                <div class="fs-16 marginl10" style="color:#F6CB9C">
                                    限时开通¥
                                    <span class="fs-20">{{upVipInfo.lostVipDays ? upVipInfo.renewPrice : upVipInfo.price}}</span>
                                    /年
                                    <del>
                                        ¥{{ upVipInfo.lostVipDays ? upVipInfo.renewOriginalPrice : upVipInfo.originalPrice }}
                                    </del>
                                </div>
                                <div class="up-message pos-a text-red bg-red fs-12">
                                    <span class="text-white">立返{{ getAllCouponAmount }}元红包</span>
                                </div>
                            </div>
                            <div class="text-center fs-10 text-dark bg-white paddingv20" data-scp="fwxy.0">开通即视为同意<a
                                style="color:#107EFF" @click="showAgreement = true">《UP会员服务协议》</a>即买生效,可在「我的」页面查看
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cmui-popup class="agreement" :visible.sync="showAgreement" position="center" :stop-page-scroll="true"
                    :mask-event="true">
            <div class="fs-17">
                <div class="text-center padding20">UP会员服务协议</div>
                <div class="padding20 text-dark"
                     style="max-height: 350px;overflow:auto;">
                    <div>提示条款</div>
                    <div>
                        各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
                    </div>
                    <div>
                        【审慎阅读】您在申请开通大商天狗会员（定义见下文）流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对协议有任何疑问，可向大商天狗客服咨询。
                    </div>
                    <div>
                        【签约动作】当您按照大商天狗会员开通页面提示阅读并同意本协议且完成全部开通程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与大商天狗达成一致，成为大商天狗会员。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止开通程序。
                    </div>
                    <div>
                        【协议范围】本协议由您与大商天狗共同签署，作为《大商天狗网软件许可使用协议》的补充，与《大商天狗网软件许可使用协议》构成统一整体并适用《大商天狗网隐私保护政策》。还请您在使用大商天狗会员服务前，仔细阅读并了解以上协议、政策，以做出适当选择。本协议内容包括协议正文及所有大商天狗已经公布的适用于所有会员用户的各类服务条款及规则，未来大商天狗会以本协议为基础，继续丰富相关的服务条款与规则，并依法定程序公布生效。所有条款与规则为协议不可分割的组成部分，与协议具有同等法律效力。
                    </div>
                    <div>一、定义</div>
                    <div>
                        1.大商天狗会员（以下简称会员）：指在大商天狗具有良好消费记录的个人注册用户在签署本协议并根据大商天狗公布的收费标准支付相应的费用或确认会员资格绑定后获取的特殊资格。
                    </div>
                    <div>2.大商天狗会员权益包括：</div>
                    <div>
                        指用户基于其会员资格所享有的特殊权益，包括特定商品的优惠权益、特定服务权益等，具体权益内容将通过“会员中心”进行不定期更新，请予以关注。
                    </div>
                    <div>3.会员服务: 指为保障用户获取或使用会员权益，大商天狗向用户提供的各项服务。</div>
                    <div>二、服务开通</div>
                    <div>
                        2.1大商天狗会员服务仅针对交易及使用记录良好，据大商天狗系统判断历史订单及关联账号均不存在违反诚实信用原则等非恶意用户开放获取资格，在您成功开通（包括续费、重新开通）前，您和大商天狗的选择是双向的，您有权选择是否开通，大商天狗亦有权选择接受或拒绝您的开通申请。
                    </div>
                    <div>
                        2.2您应确保在大商天狗会员服务开通及使用过程中，始终具备完全民事权利能力和完全民事行为能力，并确保您具有签订和履行本协议项下权利义务之实际能力，否则因此导致的所有后果将由您或您的监护人自行承担。
                    </div>
                    <div>2.3大商天狗会员服务开通前，您需要注册或登录大商天狗帐号，以确定您的主体身份信息及完成支付。</div>
                    <div>
                        2.4您申请开通大商天狗会员服务时，需根据页面提示支付相应的会员服务费用后方可完成开通。基于权益调整、市场与业务的发展，大商天狗可能会调整会员服务开通所需会员服务费用。会员服务费用、权益调整自公布之日起生效，您于生效前已开通的大商天狗会员服务不受影响，但该大商天狗会员服务到期后若需续费开通，则需按照调整后已生效的费用标准支付并享受调整后的会员权益。增值服务开始收费前大商天狗将以适当的方式通知您具体标准，您有权选择拒绝收费的增值项目。
                    </div>
                    <div>2.5 为使您更好地使用大商天狗的的各项会员服务，保障您的账户安全，大商天狗可以要求您按照相关法律法规规定完成实名认证。</div>
                    <div>三、大商天狗会员服务使用</div>
                    <div>3.1大商天狗会员服务</div>
                    <div>会员服务有效期为一年（366天），自服务开通之日起计算，享受会员权益。</div>
                    <div>若您在有效期届满后希望继续享受大商天狗会员服务的，则需续费或重新申请。</div>
                    <div>3.2大商天狗会员权益包括但不限于以下部分或全部类型（实际权益类型可能出现新增或减少，实际权益以具体会员权益说明为准）：</div>
                    <div>1）特定商品的优惠，即在购买特定商品过程中，通过享受优惠价格、获得折扣让利等方式获取的特殊权益；</div>
                    <div>
                        2）特定的优惠券，即可获得定时和不定时发放的各类优惠券，包括税费券、运费券等特殊权益，优惠券的具体使用规则以券面明确的规则及大商天狗优惠券说明为准；
                    </div>
                    <div>3）特定服务，会员日专享权益；</div>
                    <div>4）其他权益。</div>
                    <div>具体权益请参照《大商天狗会员权益规则》。</div>
                    <div>
                        3.3为了改善用户体验、完善服务内容、保证大商天狗会员与大商天狗提供服务的商业诉求一致，大商天狗有权对会员及/或其相关服务、权益、功能、界面等进行更新、修改，包括开发新功能／权益、删除旧功能／权益等。您可按照变更后会员的实际情况继续使用相应权益、功能或服务并适用本协议的相关约定。
                    </div>
                    <div>
                        3.4会员服务及会员权益仅限您本人使用，开通会员服务、获取会员权益的账户作为您享受相应服务及权益的重要身份标识，用户名、密码和生物特征（如有）均由您自行设置并保管，大商天狗在任何时候均不会主动要求您提供您的会员账户密码。会员账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，大商天狗并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
                    </div>
                    <div>
                        3.5大商天狗会员账户限本人使用，与您的会员权益及资格密切挂钩，任何将您本人账户交由他人使用的行为均可能会造成您本人账户被冻结、撤销，会员权益亦可能被撤销、冻结，因此请您不要将您的账户给予他人使用。从公平合理的角度，您应知晓所有通过该账户实现的操作产生的全部后果由您自行承担。
                    </div>
                    <div>
                        3.6【不当使用会员服务】您确保您将合理使用大商天狗会员服务，不利用会员服务进行盈利或非法获利，不以任何形式转让或转移您所享有的会员服务或会员权益，不代下单，不以任何方式直接或间接将会员服务或会员权益借给他人使用。若大商天狗有合理理由怀疑您存在任何不当使用会员服务行为时，大商天狗将取消您的会员资格、作废会员权益且您无权要求大商天狗退还您所支付的会员服务费用。您应对您不当使用会员服务的行为及后果（包括损失）负责，若因此给大商天狗造成损失的，大商天狗有权向您追偿。
                    </div>
                    <div>
                        3.7【违背诚实信用】您保证您在获取和使用会员服务过程中应遵守诚实信用原则，若大商天狗有合理理由怀疑您存在以下任一情形的，您将可能面临会员服务开通申请被拒绝、已开通的会员服务被终止或中止、已绑定或获取的会员权益被全部／部分取消或暂停使用，且您无权要求退还已支付的会员服务费用（如有）：
                    </div>
                    <div>
                        a）通过盗用他人身份信息等任何不正当手段或以违反诚实信用原则的方式开通会员服务的，如恶意绕过正常开通流程；
                    </div>
                    <div>
                        b）同一用户注册、持有、使用或控制多个会员账号。其中，同一用户是指大商天狗账户、手机号码、支付账号、身份证号码、设备号、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的；
                    </div>
                    <div>
                        c）用户在使用会员服务时，存在利用秒杀器等工具下单、套取优惠利差、虚假下单交易、提供虚假交易信息等扰乱交易秩序、违反交易规则的行为；
                    </div>
                    <div>d）经合理判断，会员使用会员权益获取的商品或服务并非个人生活所需，或非用于个人消费或使用的；</div>
                    <div>e）其他违反诚实信用原则的行为。</div>
                    <div>
                        且，大商天狗有权自行拒绝您在前述情形下提交的购买需求，若您已下达订单的，大商天狗有权据此取消订单，在此情形下，除法律明确规定外，大商天狗无需承担任何责任；同时，大商天狗有权视情况冻结您的登录帐号，使之无法通过大商天狗下达订单、购买商品。
                    </div>
                    <div>
                        3.8您知悉并同意，为保证您充分享受会员服务、避免您错过优质会员权益，大商天狗可以通过消息、通知、短信等形式，向您提供会员权益相关信息。
                    </div>
                    <div>四、大商天狗会员服务终止</div>
                    <div>4.1您应理解大商天狗会员服务具备一定有效期，有效期届满后您未续费或重新开通的，会员服务终止，对应的会员权益失效。</div>
                    <div>
                        4.2您应理解按本协议及相关规则支付会员服务费用以及按本协议约定履行义务是您使用会员服务的前提，如您违反本协议的相关约定，大商天狗会视您的实际违约情况根据本协议约定选择中止、终止或解除本协议。
                    </div>
                    <div>
                        4.3您知悉并确认，您所支付的会员服务费用代表您开通、使用大商天狗会员服务时大商天狗所付出的整体成本和努力，无法按照会员权益或有效期进行拆分。您在申请、开通或使用会员服务时，若出现以下情形，大商天狗将终止或中止对您的会员服务，且您无权要求退还部分或全部会员服务费用：
                    </div>
                    <div>1）您中途主动取消大商天狗会员服务、放弃会员权益或终止资格的；</div>
                    <div>2）大商天狗根据《大商天狗网软件许可使用协议》、交易规则、本协议、会员权益规则等协议及规则注销您的帐号、终止您的大商天狗会员资格的；</div>
                    <div>4.4任何退卡行为及大商天狗认定您为违反本协议或任何相关法律的行为、欺诈或滥用会员的行为、或损害大商天狗利益或伤害其他用户的行为而导致的终止，大商天狗不予退款。</div>
                    <div>
                        4.5本协议的终止并不影响终止前您与大商天狗基于本协议产生的权利义务。因您的原因导致大商天狗遭受第三方索赔、行政部门处罚等，您应当赔偿大商天狗因此产生的损失及/或发生的费用，包括合理的律师费用、调查取证费用等，并消除因此给大商天狗带来的负面影响。
                    </div>
                    <div>五、责任限制</div>
                    <div>
                        5.1您理解大商天狗将尽最大努力确保本服务及其所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术及大商天狗的服务能力，对于下述原因导致的协议履行障碍、瑕疵、延后或内容变更等情形，导致您直接或间接损失，您理解并同意大商天狗无需承担责任：
                    </div>
                    <div>5.1.1因自然灾害、罢工、暴乱、战争、恐怖袭击、政府行为、司法行政命令等不可抗力因素；</div>
                    <div>
                        5.1.2出于善意的维护和管理网络秩序的目的，大商天狗设置的违规行为发现和排查机制误认为您存在违规行为，导致对您的服务中止，但根据您的请求或申请及时纠正或恢复的；
                    </div>
                    <div>5.1.3因电信部门技术调整或故障、通讯网络故障等公共服务因素或第三人因素；</div>
                    <div>5.1.4用户自身设备的软件、系统、硬件和通信线路出现故障，或用户通过非本协议项下约定的方式使用本服务的；</div>
                    <div>5.1.5大商天狗已善意管理，但出现常规或紧急设备/系统的故障/维护、网络信息与数据安全等情况。</div>
                    <div>六、大商天狗会员服务争议解决</div>
                    <div>
                        6.1本协议适用中华人民共和国的法律。本协议任一条款在任何程度上被认定为无效或无法履行的，在其有效且可被履行的范围内，该条款仍应当被最大限度地履行，且本协议其他条款的法律效力不受影响。
                    </div>
                    <div>6.2如您在使用会员服务过程中出现纠纷，您与大商天狗应友好协商解决。经协商无法最终解决的，应向大商天狗网所在地有管辖权的人民法院起诉。</div>
                    <div>七、其他</div>
                    <div>
                        7.1由于互联网高速发展，您与大商天狗签署的本协议列明的条款并不能完整罗列和涵盖您与大商天狗之间的所有权利与义务，现有的约定也不能完全保证符合未来发展的需求。因此，大商天狗可根据国家法律法规变化及维护服务秩序、保护用户权益的需要，不时修改本协议，变更后的协议将在大商天狗网以公示的方式通知您，无需单独通知。修改后的协议于公示时生效。协议条款修改后，您继续使用会员服务的，即视为您已阅读并接受修改后的协议。
                    </div>
                    <div>
                        7.2大商天狗将可能向特定用户提供不同的会员试用或其他临时性的会员服务，除非在具体服务中另行说明，否则该等试用或临时性会员服务均受限于本服务协议。试用用户可随时（通过您的账户）选择在试用期结束时不成为大商天狗会员。
                    </div>
                    <div>7.3大商天狗未能及时行使本协议项下的任何权利不构成对任何权利的放弃。</div>
                    <div>7.4如您有其他与“大商天狗会员服务”相关的问题，可以通过大商天狗公布的联系方式联系客服进行反馈。</div>
                    <div>
                        7.5大商天狗始终在不断变更和改进服务。大商天狗根据自身商业决策、政府行为、不可抗力等原因可能会选择中止、中断或终止大商天狗会员服务。如有此等情形发生，大商天狗会采取公告的形式提前通知您，但不承担由此对您造成的任何损失。除法律法规另有明确规定外，大商天狗有权不经您申请，直接按照会员权益规则向您退还未履行的大商天狗会员服务对应的费用。
                    </div>
                    <div>八、通知</div>
                    <div>8.1 您在开通大商天狗会员服务时，应提供有效的联系方式，包括电子邮件地址、联系电话、联系地址等，大商天狗可以按照前述任一方式向您发出通知。</div>
                    <div>
                        8.2 上述联系方式适用于法院送达。您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
                    </div>
                </div>
                <div class="text-center text-blue padding20 bordert"
                     @click="showAgreement = false" data-scp="close.1">我知道了
                </div>
            </div>
        </cmui-popup>
    </div>
</template>

<script>
import memberService from 'spa/lib/api/member.js';
import {orderPay} from '../../../apps/purchase/payOrder/util';
import orderService from 'spa/lib/api/order.js';
import {setCookie, getCookie} from '../../../lib/util'

export default {
    name: 'tg-drawer',
    props: {
        showState: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object
        },
        source: {
            type: String
        },
        tgPrice: {
            type: Number,
            default: 0
        },
        url: {}
    },
    data() {
        return {
            show: this.showState,
            showAgreement: false,
            upVipBaseInfo: this.info,
            orderProcess: false,
            upVipInfo: {},
            upVipDis: [{
                title: '星品95折起'
                , subTitle: '同享其他优惠'
                , icon: '//image1.51tiangou.com/tgou2/img2/product/img-up_1.png'
                , link: true
            }, {
                title: '每日专享秒杀'
                , subTitle: '天天有低价'
                , icon: '//image1.51tiangou.com/tgou2/img2/product/img-up_2.png'
                , link: true
            }, {
                title: '专属客服'
                , subTitle: '1V1即时响应'
                , icon: '//image1.51tiangou.com/tgou2/img2/product/img-up_4.png'
                , link: true
            }, {
                title: '更多权益'
                , subTitle: '敬请期待'
                , icon: '//image1.51tiangou.com/tgou2/img2/giftCard/more.png'
                , link: true
            }]
        }
    },
    created() {
        this.initData()
    },
    computed: {
        getAllCouponAmount() {
            const sum = this.upVipBaseInfo.vipCouponList.reduce((pre, cur) => {
                return Number(cur.value) + pre
            }, 0)
            return sum.toFixed(2)
        }
    },
    watch: {
        showState(newVal) {
            this.show = newVal
        }
    },
    methods: {
        initData() {
            memberService.upVipInfo().then(data => {
                this.upVipInfo = data
            })
        },
        hidePanel() {
            this.show = false;
            this.$dispatch('closeDrawer', this.show);
        },
        buyUpVip() {
            if (this.orderProcess) {
                return;
            }
            this.orderProcess = true;
            let price = this.upVipInfo.lostVipDays ? this.upVipInfo.renewPrice : this.upVipInfo.price;
            orderService.tgVipOrder({
                useCatch: false,
                data: {price}
            }).then((data) => {
                // 改为跳转小程序支付
                // orderPay('301', data.vipOrderId, maple.cookie('storeId'), this.url, 7, null, this.upVipInfo.price)
                tg.changePage(`/purchase/payOrder.html?orderId=${data.vipOrderId}&bizType=7&totalAmount=${price}`);
            });
        }
    },
}
</script>
<style scoped lang="scss" type="text/scss">
.up-box > div {
    border-radius: 8px;
    background: url('//image1.51tiangou.com/tgou2/img2/product/bg-up.png') no-repeat center;
    background-size: 100% 100%;
    min-height: 50px;
    width: calc(50% - .2666666667rem);
    color: #242630;
}

/* .up-box>div:nth-of-type(1){
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
}
.up-box>div:nth-of-type(2){
  grid-column: 2 / span 1;
  grid-row: 1 / span 1;
} */
.up-list {
    background: #F5F4F9;
    border-radius: 8px;
}

.up-btn {
    background-image: linear-gradient(185deg, #666666 0%, #000000 100%);
    border-radius: 20px;
}

.up-message {
    border-radius: 20px;
    line-height: 20px;
    padding: 0 10px;
    left: 70px;
    bottom: 38px;
}

.up-message:before {
    content: '';
    width: 0;
    height: 0;
    border: 6px solid;
    position: absolute;
    bottom: -10px;
    left: 30px;
    border-color: currentColor transparent transparent;
}
</style>
